import instance from "./axiosInstance"; // Your existing Axios instance

const api = {
  get: async (endpoint, params = {}) => {
    try {
      const response = await instance.get(endpoint, { params });
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },
  post: async (endpoint, body = {}) => {
    try {
      const response = await instance.post(endpoint, body);
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },
  put: async (endpoint, body = {}) => {
    try {
      const response = await instance.put(endpoint, body);
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },
  patch: async (endpoint, body = {}) => {
    try {
      const response = await instance.patch(endpoint, body);
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },
  delete: async (endpoint) => {
    try {
      const response = await instance.delete(endpoint);
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },
};

// Centralized error handling
const handleError = (error) => {
  if (error.response) {
    // Server responded with a status outside the 2xx range
    console.error("API Error:", error.response.data.message || error.response.statusText);
    return { error: error.response.data.message || "حدث خطأ في الخادم" };
  } else if (error.request) {
    // Request was made, but no response received
    console.error("Network Error:", error.message);
    return { error: "لا يمكن الاتصال بالخادم. تحقق من اتصالك بالإنترنت" };
  } else {
    // Something happened in setting up the request
    console.error("Error:", error.message);
    return { error: "حدث خطأ غير متوقع" };
  }
};

export default api;
